import { render } from "./MessageRoutes.vue?vue&type=template&id=e6aa9fe8&scoped=true"
import script from "./MessageRoutes.vue?vue&type=script&lang=js"
export * from "./MessageRoutes.vue?vue&type=script&lang=js"

import "./MessageRoutes.vue?vue&type=style&index=0&id=e6aa9fe8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6aa9fe8"]])

export default __exports__